import React from 'react';
import _ from 'lodash';
import {
  PageHeader,
  PageHeaderNavigation,
  PageHeaderNavigationLink
} from 'components/clarity-ui';

/**
 * Site Navigation Layout.
 */
class ClassifierPageHeader extends React.Component {

  renderPageHeaderNavigationLinks (selectedClassifier) {
    const navigationLinks = [];
    if ( _.isEmpty(selectedClassifier)) {
      navigationLinks.push('Classifiers');
    } else {
      navigationLinks.push(
          <PageHeaderNavigationLink key={'classifiers-page-header-nav-0'} linkTo="/classifiers/0">
            Classifiers
          </PageHeaderNavigationLink>
      );
      navigationLinks.push(selectedClassifier);
    }
    return navigationLinks;
  }

  /**
  * Render the component
  *
  * @return {JSX} JSX component markup.
  **/
  render () {
    const { selectedClassifier, subhead, title } = this.props;
    return (
      <PageHeader title={title} subhead={subhead}>
        <PageHeaderNavigation>
          { this.renderPageHeaderNavigationLinks(selectedClassifier) }
        </PageHeaderNavigation>
      </PageHeader>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Icon component
 */
ClassifierPageHeader.propTypes = {
};

export default ClassifierPageHeader;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierPageHeader.component.jsx